e360.service('experiencesService', [
   'apiHelper',
   'experiencesConstants',
   'session',

   function (apiHelper, experiencesConstants, session) {
      var self = {
         getDefaultImage: function (model, imageId, lang) {
            var defLang = session.getCampaign().defaultLanguage;

            // check the current campaign's default language first
            if ((lang !== defLang) && model.settings.uploads[imageId] && model.settings.uploads[imageId][defLang]) {
               return model.settings.uploads[imageId][defLang];
            }

            // check brand settings starting with current language, then default language
            // then the default for the image id
            var brandUploads = session.getBrand().settings.experience.uploads;

            // header image for rsvp, qr, media, email
            if (imageId === 'headerImage') {
               if (this.isRsvp(model.type) || this.isMedia(model.type) || this.isQRCode(model.type)) {
                  if (brandUploads.genericHeader) {
                     if (brandUploads.genericHeader[lang]) {
                        return brandUploads.genericHeader[lang];
                     }

                     if (brandUploads.genericHeader[defLang]) {
                        return brandUploads.genericHeader[lang];
                     }
                  }
               }

               if (this.isEmail(model.type)) {
                  if (brandUploads.emailHeader) {
                     if (brandUploads.emailHeader[lang]) {
                        return brandUploads.emailHeader[lang];
                     }

                     if (brandUploads.emailHeader[defLang]) {
                        return brandUploads.emailHeader[defLang];
                     }
                  }
               }
            }

            // app backgrounds
            if (imageId === 'background' && this.isApp(model.type)) {
               var key = model.settings.device === 1 ? 'iPhoneBackground' : 'iPadBackground';

               if (brandUploads[key]) {
                  if (brandUploads[key][lang]) {
                     return brandUploads[key][lang];
                  }

                  if (brandUploads[key][defLang]) {
                     return brandUploads[key][defLang];
                  }
               }
            }

            // no default found
            return null;
         },

         /**
          * Accepts an object of arguments or a single ID to find an experience type
          * @param {int|object} args
          * @returns {object}
          */
         getType: function(args) {
            var type;

            if (args % 1 === 0) {
               args = { id: args };
            }

            _.each(experiencesConstants.EXPERIENCES, function (exp) {
               var exists = _.findWhere(exp, args);
               if (exists) {
                  type = angular.copy(exists);
               }
            });

            return type;
         },

         /**
          * Returns the type matching the unique uri slug
          * @param {string} slug
          * @returns {object}
          */
         getTypeBySlug: function(slug) {
            return this.getType({slug: slug});
         },

         /**
          * Returns true if the experience is a QRCode Site.
          * @param {int} id
          * @returns {boolean}
          */
         isQRCode: function(id) {
            return experiencesConstants.TYPE_QRCODE == Number(id);
         },

         /**
          * Returns true if the experience is a Passbook Site.
          * @param {int} id
          * @returns {boolean}
          */
         isPassbook: function(id) {
            return experiencesConstants.TYPE_PASSBOOK == Number(id);
         },

         /**
          * Returns true if the experience is an email
          * @param {int} id
          * @returns {boolean}
          */
         isEmail: function(id) {
            return experiencesConstants.TYPE_EMAIL == Number(id);
         },

         /**
          * Returns true if the experience is an rsvp site
          * @param {int} id
          * @returns {boolean}
          */
         isRsvp: function(id) {
            return experiencesConstants.TYPE_RSVP_SITE == Number(id);
         },

         /**
          * Returns true if the experience is a media page
          * @param {int} id
          * @returns {boolean}
          */
         isMedia: function(id) {
            return experiencesConstants.TYPE_MEDIA_PAGE == Number(id);
         },

         /**
          * Returns true if the experience is an app workflow
          * @param {int} id
          * @returns {boolean}
          */
         isApp: function(id) {
            return experiencesConstants.TYPE_APP == Number(id);
         },

         /**
          * Returns true if the experience is an sms
          * @param {int} id
          * @returns {boolean}
          */
         isSMS: function(id) {
            return experiencesConstants.TYPE_SMS == Number(id);
         },

         /**
          * Returns true if the experience is a self reg site
          * @param {int} id
          * @returns {boolean}
          */
         isSelfReg: function(id) {
            return experiencesConstants.TYPE_WEB_REG == Number(id);
         },

         /**
          * Returns true if the experience is a sub experience of another.
          * @param experience
          * @returns {boolean}
          */
         isSubExperience: function(experience) {
            return (
               experiencesConstants.TYPE_EMAIL == Number(experience.type) &&
               experience.settings.emailName !== 'PostEventNotAttend' &&
               experience.settings.emailName !== 'PostEventThankyou'
            );
         },

         /**
          * Converts a type id into a URI-friendly slug based on the type name
          * @param {int} id
          * @returns {string}
          */
         typeIdToSlug: function (id) {
            var type = this.getType(id);
            if (!type) {
               return 'unknown';
            }

            return type.label.toLowerCase().replace(/\s/gi, '-');
         },

         /**
          * Scans images in the experience to build a color palette of dominant colors for color pickers
          */
         bindExperiencePalette: function() {
            $(document).on('focus.minicolors', '.minicolors-input', function() {
               var ele = $(this);
               if (ele.attr('data-thief')) {
                  return;
               }

               ele.attr('data-thief', true);
               var paletteEle = ele.parent().find('.editor-palette');
               paletteEle.find('.palette-colors').empty();

               var componentToHex = function(c) {
                  var hex = c.toString(16);
                  return hex.length == 1 ? "0" + hex : hex;
               };

               var rgbToHex = function(r, g, b) {
                  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
               };

               var addColor = function(color) {
                  var c = angular.element('<div class="palette-color"></div>');
                  c.css({
                     'background-color': 'rgb(' + color[0] + ', ' + color[1] + ', ' + color[2] + ')',
                  }).click(function() {
                     var hex = rgbToHex(color[0], color[1], color[2]).toUpperCase();
                     ele.val(hex);
                     ele.trigger('keyup');
                  });

                  paletteEle.find('.palette-colors').append(c);
               };

               if (paletteEle.length === 0) {
                  paletteEle = angular.element(
                     '<div class="minicolors-panel editor-palette">' +
                        '<h2>Experience Palette</h2>' +
                        '<div class="palette-colors"></div>' +
                     '</div>'
                  );
                  ele.parent().append(paletteEle);
               } else {
                  paletteEle.find('.palette-colors').html('');
               }

               //paletteEle.hide();

               var images = [];

               // First find all unique background images
               $.each($('.experience-editor *').filter(function() {
                  var bg = window.getComputedStyle(this,null).getPropertyValue('background-image');
                  return bg !== 'none' && bg.indexOf('amazonaws') > -1;
               }), function(idx, el) {
                  var style = el.currentStyle || window.getComputedStyle(el, false);
                  var img = style.backgroundImage.slice(4, -1).replace(/"/g, "");
                  if (images.indexOf(img) == -1) {
                    images.push(img);
                  }
               });

               // Second find all unique static images
               $.each($('.experience-editor .img-upload img').filter(function() {
                  var src = $(this).attr('src');
                  return src.indexOf('data:image') > -1 || src.indexOf('amazonaws') > -1;
               }), function(idx, el) {
                  var img = $(el).attr('src');
                  if (images.indexOf(img) == -1) {
                    images.push(img);
                  }
               });

               // Iterate unique images to add color thief
               _.each(images, function(img) {
                  var el = document.createElement('img');
                  el.setAttribute('crossOrigin', 'Anonymous');
                  el.src = img;
                  el.onload = function() {
                     var thief = new ColorThief();
                     var palette = thief.getPalette(el, 8);
                     _.each(palette, addColor);

                     if (ele.is(':focus')) {
                        paletteEle.show();
                     }

                     el.onload = null;
                  };
               });
            });
         },

         listTemplates: function (label) {
            var url = 'campaignExperiences/listTemplates';

            if (label) {
               url = url + '?label=' + label;
            }

            return apiHelper.get(url);
         },

         testEmail: function (id, locale, mergeVars) {
            return apiHelper.post('campaignExperiences/' + id + '/testEmail/' + locale, mergeVars);
         },

         list: function (campaignId) {
            return apiHelper.get('campaignExperiences?campaignId=' + campaignId)
               .then(function(experiences) {
                  var apps = [];

                  // experience list expects `typeDefinition` property
                  _.each(experiences, function(exp) {
                     var args = {id: exp.type };
                     if (self.isApp(exp.type)) {
                        args.device = exp.settings.device;
                        apps.push(exp);

                        // custom experience models have an ID of zero, app
                        // exp-node directive expects ID to have a value
                        // for identifying/locking custom app experiences
                        if (exp.isCustom) {
                           exp.id = stringToId(exp.settings.name);
                        }
                     } else if (self.isEmail(exp.type)) {
                        args.email_name = exp.settings.emailName;
                     }

                     exp.typeDefinition = self.getType(args);
                  });

                  // filter experience models that don't have a typeDef
                  // these models have no representation in experience list
                  // e.g. emails of type `RsvpGuestReminder` or `RsvpReferrerStatus`
                  experiences = _.filter(experiences, function(exp) {
                    return exp.typeDefinition;
                  });

                  experiences.apps = apps;
                  return experiences;
               });
         },

         get: function (id) {
            return apiHelper.get('campaignExperiences/' + id);
         },

         cloudFlareActivate: function(id, domain) {
            var params = {};
            if (domain) {
               params.domain = domain;
            }

            return apiHelper.post('campaignExperiences/' + id + '/cloudFlare', params);
         },

         cloudFlareVerify: function(id) {
            return apiHelper.get('campaignExperiences/' + id + '/cloudFlare');
         },

         getSettings: function (slug) {
            return apiHelper.get('campaignExperiences/' + slug + '/settings');
         },

         create: function (model) {
            return apiHelper.post('campaignExperiences', model);
         },

         update: function (model) {
            return apiHelper.post('campaignExperiences/' + model.id, model);
         },

         del: function (id) {
            return apiHelper.del('campaignExperiences/' + id);
         },

         hasExperienceType: function (campaignId, typeDef) {
            // experience list controller is already listing experiences and
            // ideally the experience list would be a model we could pass
            // around and query the state of existing experiences

            // sadly the experiences are just loaded and dropped into the
            // controller scope so we have no clean way to get to them
            // which means to test if a given experience type already exists
            // outside the scope of the experience list controller we must
            // re-list the experiences and iterate

            return self.list(campaignId).then(function (experiences) {
               return _.any(experiences, function (experience) {
                  return experience.typeDefinition.slug === typeDef.slug;
               });
            });
         }
      };

      return self;
   }
]);

function stringToId(val) {
   return _.reduce(Array.from(val), function(memo, val) {
      return memo + val.charCodeAt(0);
   }, 0);
}
